import React from 'react'

export interface IAppTableColumnProps {
	title?: string
	field?: string
	width?: number
	render?: (data: any, dataIndex: number) => JSX.Element | string
	sorter?: boolean
	sortField?: string
	align?: 'left' | 'right' | 'center'
	format?: string
	fixed?: 'left' | 'right' | '' | string
	expand?: boolean
	editType?: 'string' | 'number' | 'date' | 'select'
	maxNumber?: number
	minNumber?: number
	maxLength?: number
	paramKeyName?: string
	editAllow?:(data: any, dataIndex: number) => boolean
}

export class AppTableColumn extends React.Component<IAppTableColumnProps> {
	static defaultProps: IAppTableColumnProps = {
		align: 'left',
		format: '',
		fixed: '',
	}
}

export class AppTableColumnCheckbox extends React.Component<IAppTableColumnProps> {
	static defaultProps: IAppTableColumnProps = {
		width: 60,
		title: '',
		field: '__table_check_box',
		align: 'center',
	}
}

export class AppTableColumnIndex extends React.Component<IAppTableColumnProps> {
	static defaultProps: IAppTableColumnProps = {
		width: 60,
		title: '序号',
		field: '__table_index',
		align: 'center',
	}
}

export class AppTableColumnDate extends React.Component<IAppTableColumnProps> {
	static defaultProps: IAppTableColumnProps = {
		align: 'center',
		format: 'YYYY-MM-DD',
		fixed: '',
	}
}

export class AppTableColumnDateTime extends React.Component<IAppTableColumnProps> {
	static defaultProps: IAppTableColumnProps = {
		align: 'center',
		format: 'YYYY-MM-DD HH:mm:ss',
		fixed: '',
	}
}
export class AppTableColumnInt extends React.Component<IAppTableColumnProps> {
	static defaultProps: IAppTableColumnProps = {
		align: 'right',
		format: '#,###',
		fixed: '',
	}
}
export class AppTableColumnMoney extends React.Component<IAppTableColumnProps> {
	static defaultProps: IAppTableColumnProps = {
		align: 'right',
		format: '#,###.00',
		fixed: '',
	}
}

export class AppTableColumnAction extends React.Component<IAppTableColumnProps> {
	static defaultProps: IAppTableColumnProps = {
		align: 'right',
		fixed: '',
		title: '操作',
	}
}

export class AppTableEditColumnString extends React.Component<IAppTableColumnProps> {
	static defaultProps: IAppTableColumnProps = {
		align: 'left',
		fixed: '',
		editType: 'string',
	}
}

export class AppTableEditColumnInt extends React.Component<IAppTableColumnProps> {
	static defaultProps: IAppTableColumnProps = {
		align: 'left',
		fixed: '',
		editType: 'number',
		format: '#,###',
	}
}

export class AppTableEditColumnMoney extends React.Component<IAppTableColumnProps> {
	static defaultProps: IAppTableColumnProps = {
		align: 'left',
		fixed: '',
		editType: 'number',
		format: '#,###.00',
	}
}

export class AppTableEditColumnDate extends React.Component<IAppTableColumnProps> {
	static defaultProps: IAppTableColumnProps = {
		align: 'left',
		fixed: '',
		editType: 'date',
		format: 'yyyy-MM-dd',
	}
}



// WEBPACK FOOTER //
// ./src/components/AppTable/AppTableColumn.tsx